/**
 * Lightweight "Recently Viewed" for the cart drawer / cart page.
 * - <track-product-view> sits on the product page and records the
 *   current product into localStorage.
 * - <recently-viewed> sits in the cart drawer/page and renders the
 *   last few viewed products (excluding the current cart's items).
 * No app, no extra network calls beyond the small product JSON fetch.
 */
(function () {
  const STORAGE_KEY = 'lux_recently_viewed';
  const MAX_ITEMS = 8;

  function readViewed() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  }

  function writeViewed(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    } catch {
      /* storage unavailable — silently no-op */
    }
  }

  if (!customElements.get('track-product-view')) {
    class TrackProductView extends HTMLElement {
      connectedCallback() {
        const entry = {
          handle: this.dataset.handle,
          title: this.dataset.title,
          image: this.dataset.image,
          price: this.dataset.price,
          url: this.dataset.url,
        };
        if (!entry.handle) return;
        const list = readViewed().filter((p) => p.handle !== entry.handle);
        list.unshift(entry);
        writeViewed(list);
      }
    }
    customElements.define('track-product-view', TrackProductView);
  }

  if (!customElements.get('recently-viewed')) {
    class RecentlyViewed extends HTMLElement {
      connectedCallback() {
        const excludeHandle = this.dataset.excludeHandle || '';
        const items = readViewed()
          .filter((p) => p.handle !== excludeHandle)
          .slice(0, 6);

        if (items.length === 0) {
          this.innerHTML = '';
          return;
        }

        this.innerHTML = `
          <p class="rv-heading lux-eyebrow">${this.dataset.heading || 'Recently Viewed'}</p>
          <div class="rv-list">
            ${items
              .map(
                (p) => `
              <a class="rv-card" href="${p.url}">
                <img src="${p.image}" alt="${p.title}" loading="lazy" width="72" height="72">
                <span class="rv-card__title">${p.title}</span>
              </a>`
              )
              .join('')}
          </div>
        `;
      }
    }
    customElements.define('recently-viewed', RecentlyViewed);
  }
})();
